import React from 'react'
import PropTypes from 'prop-types'
import FastAvatar from '../../../molecules/FastAvatar'

function SelectMenuOption ({ option, onClick }) {
  return (
    <div
      className='flex items-center gap-sm p-sm menu-item-primary clickable font-size-xs font-thin'
      onClick={(e) => onClick(option, e)}
    >
      <FastAvatar
        avatarUrl={option.attributes?.avatarUrl}
        size='sm'
        abbreviation={option.attributes?.abbreviation}
      />
      <div>
        {option.label}
      </div>
    </div>
  )
}

SelectMenuOption.propTypes = {
  option: PropTypes.shape({
    label: PropTypes.any,
    value: PropTypes.any,
    attributes: PropTypes.shape({
      avatarUrl: PropTypes.any,
      abbreviation: PropTypes.any
    })
  }),
  onClick: PropTypes.func
}

SelectMenuOption.defaultProps = {
  onClick: () => {}
}

export default SelectMenuOption
